import * as moment from "moment";
import NotificationBase from "../NotificationBase";
import {BillPaidNotificationDataApiDto, NotificationBaseApiDto} from "../../../api/model/rest";

/**
 * Bill paid notification class.
 */
export default class BillPaidNotification extends NotificationBase {
	/**
	 * @param {string} id notification id.
	 * @param {moment.Moment} visibleFrom Notification datetime.
	 * @param {boolean} read flag if notification is marked as read.
	 * @param {string} type in this case always 'BILL_PAID'.
	 * @param {BillPaidNotificationData} data bill paid notification data object.
	 */
	constructor(readonly id: string,
		readonly visibleFrom: moment.Moment,
		readonly read: boolean,
		readonly type: string,
		readonly data: BillPaidNotificationData) {
		super(id, visibleFrom, read, type);
	}

	static fromJson(json: NotificationBaseApiDto): BillPaidNotification {
		return new BillPaidNotification(json.id, moment(json.visibleFrom), json.read, json.type,
			BillPaidNotificationData.fromJson(json.data as BillPaidNotificationDataApiDto));
	}

	copy({id = this.id, dateTime = this.visibleFrom, read = this.read, type = this.type, data = this.data}) {
		return new BillPaidNotification(id, dateTime, read, type, data);
	}
}

/**
 * Bill paid notification class data.
 */
export class BillPaidNotificationData {
	constructor(readonly jobRefNumber: string, readonly billId: string) {}

	static fromJson(json: BillPaidNotificationDataApiDto): BillPaidNotificationData {
		return new BillPaidNotificationData(json.jobRefNumber, json.billId)
	}
}
